import styled from 'styled-components';
import { LabelRegularM } from '../../../styles/globals';

export const Description = styled(LabelRegularM)`
  display: flex;
  margin: 0;
  white-space: pre-wrap;
`;
